import Vue from 'vue'
import App from './App.vue'

//主CSS
import '@/assets/style/index.css'
//markdown CSS
import '@/assets/style/markdown.css'
//markdown 目录
import '@/assets/style/markdownMenu.css'
//Ele修改
import '@/assets/style/ele.css'
//多分辨率适配
import '@/assets/style/media.css'

//Element UI扩展
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//Markdown扩展
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
//OutLine扩展
import outline from "vue-outline"
//VUE剪切板插件
import copy from 'vue-clipboard2'
//路由
import router from '@/components/router'
//数据存储
import store from '@/components/dataStore'

Vue.use(mavonEditor)
Vue.use(ElementUI)
Vue.use(outline)
Vue.use(copy)

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router,
    store,
}).$mount('#app')
